<div class="pick-coupon-container">
    <h1 mat-dialog-title>{{'Coupons.Title' | translate}}</h1>
    <div mat-dialog-content>
        <div *ngFor="let coupon of coupons" matRipple class="no-outline pointer-cursor">
            <div class="small-margin coupon-outline" (click)="couponTap(coupon)" [ngClass]="{'opaque': coupon.Available === false || coupon.FloorRejected === true}">
                <div class="flex-container-center small-margin">
                    <div class="small-margin">
                        <div class="label">{{coupon.Name}}</div>
                        <div class="detail small-margin">{{coupon.Detail}}</div>
                        <div *ngIf="coupon.Available === true && coupon.FloorRejected === true" class="detail small-margin">{{coupon.OrderFloor}}</div>
                    </div>
                    <div class="float-right price-label small-margin small-padding" style="white-space: nowrap;">{{coupon.ValueString}}</div>
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="" cdkFocusInitial>{{'Coupons.Return' | translate}}</button>
    </div>
</div>